import type { CartItem } from "./types";

/** Map cart line items to transaction product_info payload. */
export function mapCartItemsToProductInfo(items: CartItem[]): Record<string, unknown>[] {
    return items.map((i) => ({
        id: i.id,
        title: i.title,
        image: i.image,
        price: i.price,
        quantity: i.quantity,
        variant: i.variant,
        productClassId: i.productClassId,
        featureId: i.featureId,
        typeValues: i.typeValues,
        productClassIds: i.productClassIds,
        featureIds: i.featureIds,
        vendorSlug: i.vendorSlug,
        vendorUserId: i.vendorUserId,
        vendorName: i.vendorName,
        pageSlug: i.pageSlug,
    }));
}
